import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { ProblemSection } from '../components/ProblemSection';
import { HowItWorksSection } from '../components/HowItWorksSection';
import { AppMockupSection } from '../components/AppMockupSection';
import { WhyDifferentSection } from '../components/WhyDifferentSection';
import { WaitlistSection } from '../components/WaitlistSection';
export function LandingPage() {
  return <main className="min-h-screen w-full bg-[#FAF8F5] font-sans text-[#3A3A3A] overflow-x-hidden relative" data-id="element-217">
      {/* Noise Texture Overlay */}
      <div className="fixed inset-0 pointer-events-none opacity-[0.03] z-50 mix-blend-multiply" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)'/%3E%3C/svg%3E")`
    }} data-id="element-218" />

      <HeroSection data-id="element-219" />
      <ProblemSection data-id="element-220" />
      <HowItWorksSection data-id="element-221" />
      <AppMockupSection data-id="element-222" />
      <WhyDifferentSection data-id="element-223" />
      <WaitlistSection data-id="element-224" />
    </main>;
}